declare namespace $ {

	type $shm_listener__shm_hitalama_quick2_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_quick2['keydown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $mol_view__attr_shm_hitalama_quick2_2 = $mol_type_enforce<
		({ 
			'shm_hitalama_quick2_vertical': ReturnType< $shm_hitalama_quick2['vertical'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_quick2_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2['buttons'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_quick2_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_quick2_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_quick2_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__checked_shm_hitalama_quick2_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2['checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__event_shm_hitalama_quick2_8 = $mol_type_enforce<
		({ 
			pointerenter( next?: ReturnType< $shm_hitalama_quick2['pointerenter'] > ): ReturnType< $shm_hitalama_quick2['pointerenter'] >,
			pointerleave( next?: ReturnType< $shm_hitalama_quick2['pointerleave'] > ): ReturnType< $shm_hitalama_quick2['pointerleave'] >,
		})  & ReturnType< $mol_check['event'] >
		,
		ReturnType< $mol_check['event'] >
	>
	type $mol_check__sub_shm_hitalama_quick2_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	export class $shm_hitalama_quick2 extends $mol_view {
		keydown_handler( ): any
		keydown_listener( ): $shm_listener
		buttons( ): readonly(any)[]
		Panel( ): $mol_view
		hovered_title( ): string
		Hovered_title( ): $mol_view
		hovered_title_visible( ): readonly(any)[]
		checked( id: any, next?: boolean ): boolean
		pointerenter( id: any, next?: any ): any
		pointerleave( id: any, next?: any ): any
		item_hotkey( id: any): string
		Speck( id: any): $mol_view
		Label( id: any): $mol_view
		hovered_id( next?: string ): string
		vertical( ): boolean
		attr( ): ({ 
			'shm_hitalama_quick2_vertical': ReturnType< $shm_hitalama_quick2['vertical'] >,
		})  & ReturnType< $mol_view['attr'] >
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		Button( id: any): $mol_check
	}
	
}

//# sourceMappingURL=quick2.view.tree.d.ts.map